import React from 'react';
import './AppTeaser.scss';
import {Image} from "../image/Image";
import {ButtonInternal} from "../button/ButtonInternal";
import {connect} from "react-redux";
import {BUTTON_APPEARANCE} from "../button/Button";
import ButtonAnchor from "../button/ButtonAnchor";
import {getMobileOperatingSystem} from "../../../vendor/utils/Utils";

function AppTeaser(props) {
    const title = 'Neu: Die CANUSA-App';
    const text = 'Mit unserer App sind Sie auf Ihre Traumreise bestens vorbereitet. Neben Ihrer Reiseübersicht und Ihren Unterlagen finden Sie auch alle nötigen weiteren Informationen, um entspannt in den Urlaub starten zu können.';

    const userAgent = getMobileOperatingSystem();

    return (
        <>
            <div className={'app-teaser box'}>
                <div className={'app-teaser__wrapper'}>
                    <div className={'app-teaser__content'}>
                        <div className={'h3 ts-handwriting'}>{title}</div>
                        <p className={'app-teaser__content-text'}>{text}</p>
                        <div className={'app-teaser__button-wrapper'}>
                            {(userAgent === "Other" || userAgent === "iOS") &&

                            <a className={"app-teaser__link"} href="https://apps.apple.com/de/app/canusa/id6479021595?itscg=30200&itsct=apps_box_badge&mttnsubad=6479021595">
                                <img src="/assets/AppStore.svg" alt="Im App Store laden" />
                            </a>}
                            {(userAgent === "Other" || userAgent === "Android") && <a className={"app-teaser__link"} href="https://play.google.com/store/apps/details?id=com.canusa.app">
                                <img src="/assets/GooglePlay.png" alt={"Im Google Play Store laden"}  />
                            </a>}
                        </div>
                    </div>
                    <div className={'teaser__delimiter'}>
                        <div className={'teaser__delimiter-dots'}/>
                    </div>
                    <div className={'teaser__image-wrapper'}>
                        <Image
                            url={"//images.canusa.de/img/allgemein/storytelling/24-kristin-weide-utah-fam/tag-7-monument-valley.cr4032x2685-0x0.jpg"}
                            additionalClasses={'teaser__image-content'}
                            ratio={props.isDesktop ? null : {width: 16, height: 9}}
                            sizes={{
                                ultraWideDesktop: '600px',
                                wideDesktop: '27vw',
                                desktop: '25vw',
                                tablet: '40vw',
                                default: '100vw'
                            }}/>
                    </div>
                </div>
            </div>
        </>
    )

}

const mapStateToProps = (state, ownProps) => {
    return {isDesktop: state.globalStateManagement.isDesktop}
};

export default connect(mapStateToProps)(AppTeaser)

